import { useEffect } from "react";

// Injects <meta name="robots" content="noindex"> while mounted (for 404/soft-404 pages)
export const Noindex = ({ title }) => {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    if (title) document.title = title;
    return () => meta.remove();
  }, [title]);
  return null;
};
